import Text from '@creator/ui/components/Text/Text';
import { abbreviatedFormatter } from '@creator/ui/utils/number-utils';
import Link from '@src/basic-components/Link/Link';
import { ensureTokenUrl } from '@src/model/config/helpers';
import { useStoreState } from '@src/model/hooks';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface TokenStatsProps {
    tokenName: string;
}

const TokenStats: FC<TokenStatsProps> = props => {
    const { tokenName } = props;
    const { t } = useTranslation();
    const token = useStoreState(state => state.token.getToken(tokenName));

    const { numberOfMembers = 0, totalPosts = 0 } = token ?? {};

    const holdersLink = `/${ensureTokenUrl(tokenName)}/tab/holders`;
    const postsLink = `/${ensureTokenUrl(tokenName)}`;

    return (
        <div className="flex items-center flex-1 space-x-1 text-xs text-gray-500 ">
            <Link to={holdersLink}>
                <Text data-ssr="token-member-count" className="font-bold lg:hidden">
                    {abbreviatedFormatter(numberOfMembers)}
                </Text>
                <Text data-ssr="token-member-count" className="hidden font-bold lg:inline">
                    {numberOfMembers.toLocaleString()}
                </Text>
                <Text className="flex-1 ml-1">{t('tokenStats.stats.totalMembers', { count: numberOfMembers })}</Text>
            </Link>
            <Text className="font-bold">·</Text>
            <Link to={postsLink}>
                <Text data-ssr="token-post-count" className="font-bold lg:hidden">
                    {abbreviatedFormatter(totalPosts)}
                </Text>
                <Text data-ssr="token-post-count" className="hidden font-bold lg:inline">
                    {totalPosts.toLocaleString()}
                </Text>
                <Text className="flex-1 ml-1">{t('tokenStats.stats.totalPosts', { count: totalPosts })}</Text>
            </Link>
        </div>
    );
};

export default TokenStats;
